/**
 * 把页内 el-tabs 同步到地址栏 query，刷新后仍停在当前页签。
 * options.allowed 为允许的 name；dataKey 为组件 data 字段；queryKey 为 query 参数名。
 */
export function routeTabMixin(options = {}) {
  const queryKey = options.queryKey || 'tab'
  const dataKey = options.dataKey || 'activeTab'
  const allowed = Array.isArray(options.allowed) ? options.allowed : []

  return {
    created() {
      this.applyRouteTab()
    },
    watch: {
      [`$route.query.${queryKey}`]() {
        this.applyRouteTab()
      },
      [dataKey](val) {
        this.commitRouteTab(val)
      }
    },
    methods: {
      applyRouteTab() {
        const raw = this.$route && this.$route.query ? this.$route.query[queryKey] : ''
        const name = raw == null ? '' : String(raw)
        if (!name || (allowed.length && allowed.indexOf(name) < 0)) return
        const changed = this[dataKey] !== name
        if (changed) this[dataKey] = name
        if (changed && typeof this.onRouteTabRestored === 'function') this.onRouteTabRestored(name)
      },
      commitRouteTab(val) {
        if (!val) return
        if (allowed.length && allowed.indexOf(val) < 0) return
        const current = this.$route && this.$route.query ? this.$route.query[queryKey] : ''
        if (String(current || '') === String(val)) return
        const query = Object.assign({}, this.$route.query, { [queryKey]: val })
        this.$router.replace({ path: this.$route.path, query }).catch(() => {})
      }
    }
  }
}
